<template>
  <teleport to="#section-reports">
    <div
      class="temlate-report"
      id="driving-safety-template-content"
    >
      <button
        class="not-print float-left"
        onclick="html_to_excel_helper.export( this, 'driving-safety-template-content', 'Безопасность вождения', 'portrait' )"
      >
        Экспорт&nbsp;в&nbsp;EXCEL
      </button>
      <template v-if="props.isTitle">
        <div class="template-header">
          <h6 class="text-center font-weight-bold">
          Безопасность вождения, детализация видов нарушений
          </h6>

          <p
            class="text-center excel-bottom-indent excel-auto-height"
          >
            Отчет составлен по ТС {{ vehiclesStr }}
          </p>

          <p class="text-center excel-bottom-indent">
            {{ titleInterval }}
          </p>
        </div>
      </template>

      <hr class="not-print margin-none" />

      <template
        v-for="(obj, objIndex) in objects"
        :key="objIndex"
      >
        <h6 class="text-center font-weight-bold driving-safety-report__vehicle-title">
        {{ vehicleLabel(obj) }}
      </h6>

        <table
          class="driving-safety-report__table"
          border="1"
          cellpadding="5"
        >
          <thead class="sticky">
            <tr class="text-center">
              <th
                data-excelalignv="middle"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                №
              </th>
              <th
                data-excelalignv="middle"
                data-excelalignh="center"
                data-excelcolspan="10"
                colspan="10"
              >
                Наименование
              </th>
              <th
                data-excelalignv="middle"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                Количество
              </th>
              <th
                data-excelalignv="middle"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                На 100 км/пути
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(violation, i) in visibleViolations(obj)"
              :key="violation.field"
            >
              <td
                class="text-center"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                {{ i + 1 }}
              </td>
              <td data-excelcolspan="10" colspan="10">
                {{ violation.name }}
              </td>
              <td
                class="text-center"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                {{ formatCount(violation.count) }}
              </td>
              <td
                class="text-center"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                {{ formatPer100(violation.per100) }}
              </td>
            </tr>
            <tr class="font-weight-bold">
              <td
                colspan="11"
                data-excelcolspan="11"
              >
                Итого
              </td>
              <td
                class="text-center"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                {{ formatCount(objTotalCount(obj)) }}
              </td>
              <td
                class="text-center"
                data-excelalignh="center"
                data-excelcolspan="1"
                colspan="1"
              >
                {{ formatPer100(objTotalPer100(obj)) }}
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
    <div class="not-print margin-bottom"></div>
  </teleport>
</template>

<script setup>
import { watch, computed, onBeforeMount } from '@vue/runtime-core';

const props = defineProps({
  isTitle: {
    type: Boolean,
    default: true,
  },
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['outputTitleHtml']);

onBeforeMount(() => {
  const sectionReports = document.getElementById('section-reports');
  if (sectionReports) {
    sectionReports.innerHTML = '';
  }
});

const titleInterval = computed(() => {
  const first = props.data.objects[0];
  return first && first['view'] ? first['view']['t_interval'] : '';
});

const objects = computed(() => props.data.objects || []);

const vehiclesStr = computed(() =>
  objects.value.map(vehicleLabel).filter(Boolean).join(', '),
);

watch(
  () => props.isTitle,
  (cond) => {
    if (!cond) {
      emit(
        'outputTitleHtml',
        `<div class="template-header"> 
          <h6 class="text-center font-weight-bold">
            Безопасность вождения, детализация видов нарушений
          </h6>
      
          <p class="text-center excel-bottom-indent">
            Отчет составлен по ТС ${vehiclesStr.value}
          </p>
      
          <p class="text-center excel-bottom-indent">
            ${titleInterval.value}
          </p>
        </div>
      
      <p class="text-center excel-bottom-indent">
      Значения выводимые в отчет:
      </p>
      `,
      );
    }
  },
  { immediate: true },
);

const violations = [
  { name: 'Резкое торможение', field: 'hard_brake_cnt' },
  { name: 'Резкое торможение, маневрирование', field: 'hard_brake_mnvr_cnt' },
  { name: 'Резкое торможение в повороте', field: 'hard_brake_turn_cnt' },
  {
    name: 'Резкое торможение в повороте, маневрирование',
    field: 'hard_brake_turn_mnvr_cnt',
  },
  {
    name: 'Резкое внезапное торможение, опасная ДТС',
    field: 'dngrs_brake_cnt',
  },
  {
    name: 'Резкое внезапное торможение, маневрирование, опасная ДТС',
    field: 'dngrs_brake_mnvr_cnt',
  },
  {
    name: 'Резкое внезапное торможение в повороте, опасная ДТС',
    field: 'dngrs_brake_turn_cnt',
  },
  {
    name: 'Резкое внезапное торможение в повороте, маневрирование, опасная ДТС',
    field: 'dngrs_brake_turn_mnvr_cnt',
  },
  { name: 'Экстренное торможение', field: 'mrgncy_brake_cnt' },
  { name: 'Экстренное торможение, маневрирование', field: 'mrgncy_brake_mnvr_cnt' },
  { name: 'Экстренное торможение в повороте', field: 'mrgncy_brake_turn_cnt' },
  {
    name: 'Экстренное торможение в повороте, маневрирование',
    field: 'mrgncy_brake_turn_mnvr_cnt',
  },
  {
    name: 'Экстренное внезапное торможение, опасная ДТС',
    field: 'dngrs_sudden_brake_cnt',
  },
  {
    name: 'Экстренное внезапное торможение, маневрирование, опасная ДТС',
    field: 'dngrs_sudden_brake_mnvr_cnt',
  },
  {
    name: 'Экстренное внезапное торможение в повороте, опасная ДТС',
    field: 'dngrs_sudden_brake_turn_cnt',
  },
  {
    name: 'Экстренное внезапное торможение в повороте, маневрирование, опасная ДТС',
    field: 'dngrs_sudden_brake_turn_mnvr_cnt',
  },
  { name: 'Экстренное торможение, вероятность ДТП', field: 'crash_brake_cnt' },
  {
    name: 'Экстренное торможение, маневрирование вероятность ДТП',
    field: 'crash_brake_mnvr_cnt',
  },
  {
    name: 'Экстренное торможение в повороте, вероятность ДТП',
    field: 'crash_brake_turn_cnt',
  },
  {
    name: 'Экстренное торможение в повороте, маневрирование вероятность ДТП',
    field: 'crash_brake_turn_mnvr_cnt',
  },
  {
    name: 'Экстренное внезапное торможение, вероятность ДТП',
    field: 'crash_sudden_brake_cnt',
  },
  {
    name: 'Экстренное внезапное торможение, маневрирование вероятность ДТП',
    field: 'crash_sudden_brake_mnvr_cnt',
  },
  {
    name: 'Экстренное внезапное торможение в повороте, вероятность ДТП',
    field: 'crash_sudden_brake_turn_cnt',
  },
  {
    name: 'Экстренное внезапное торможение в повороте, маневрирование вероятность ДТП',
    field: 'crash_sudden_brake_turn_mnvr_cnt',
  },
  { name: 'Удар по подвеске', field: 'suspension_hit' },
  { name: 'Сильный удар по подвеске', field: 'suspension_hit_strg' },
  { name: 'Резкий правый поворот', field: 'sharp_right_turn_cnt' },
  { name: 'Резкий левый поворот', field: 'sharp_left_turn_cnt' },
  {
    name: 'Резкий правый поворот, ножной тормоз',
    field: 'sharp_right_turn_foot_brake_cnt',
  },
  {
    name: 'Резкий правый поворот, моторный тормоз',
    field: 'sharp_right_turn_engine_brake_cnt',
  },
  {
    name: 'Резкий правый поворот, тормоз ретардер',
    field: 'sharp_right_turn_retard_brake_cnt',
  },
  {
    name: 'Резкий правый поворот, ножной тормоз, моторный тормоз',
    field: 'sharp_right_turn_foot_engine_brake_cnt',
  },
  {
    name: 'Резкий правый поворот, тормоз ретардер, моторный тормоз',
    field: 'sharp_right_turn_retard_engine_brake_cnt',
  },
  {
    name: 'Резкий правый поворот, ножной тормоз, тормоз ретардер, моторный тормоз',
    field: 'sharp_right_turn_foot_retard_engine_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, ножной тормоз',
    field: 'sharp_left_turn_foot_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, моторный тормоз',
    field: 'sharp_left_turn_engine_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, тормоз ретардер',
    field: 'sharp_left_turn_retard_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, ножной тормоз, моторный тормоз',
    field: 'sharp_left_turn_foot_engine_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, тормоз ретардер, моторный тормоз',
    field: 'sharp_left_turn_retard_engine_brake_cnt',
  },
  {
    name: 'Резкий левый поворот, ножной тормоз, тормоз ретардер, моторный тормоз',
    field: 'sharp_left_turn_foot_retard_engine_brake_cnt',
  },
  { name: 'Опасный правый поворот, возможен занос', field: 'dngrs_right_turn_cnt' },
  { name: 'Опасный левый поворот, возможен занос', field: 'dngrs_left_turn_cnt' },
  {
    name: 'Опасный правый поворот, возможен занос, ножной тормоз',
    field: 'dngrs_right_turn_foot_brake_cnt',
  },
  {
    name: 'Опасный правый поворот, возможен занос, моторный тормоз',
    field: 'dngrs_right_turn_engine_brake_cnt',
  },
  {
    name: 'Опасный правый поворот, возможен занос, тормоз ретардер',
    field: 'dngrs_right_turn_retard_brake_cnt',
  },
  {
    name: 'Опасный правый поворот, возможен занос, ножной тормоз, моторный тормоз',
    field: 'dngrs_right_turn_foot_engine_brake_cnt',
  },
  {
    name: 'Опасный правый поворот, тормоз ретардер, моторный тормоз',
    field: 'dngrs_right_turn_retard_engine_brake_cnt',
  },
  {
    name: 'Опасный правый поворот, ножной тормоз, тормоз ретардер, моторный тормоз',
    field: 'dngrs_right_turn_foot_retard_engine_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, возможен занос, ножной тормоз',
    field: 'dngrs_left_turn_foot_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, возможен занос, моторный тормоз',
    field: 'dngrs_left_turn_engine_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, возможен занос, тормоз ретардер',
    field: 'dngrs_left_turn_retard_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, возможен занос, ножной тормоз, моторный тормоз',
    field: 'dngrs_left_turn_foot_engine_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, тормоз ретардер, моторный тормоз',
    field: 'dngrs_left_turn_retard_engine_brake_cnt',
  },
  {
    name: 'Опасный левый поворот, ножной тормоз, тормоз ретардер, моторный тормоз',
    field: 'dngrs_left_turn_foot_retard_engine_brake_cnt',
  },
];

const countOf = (obj, field) => Number(obj[field]) || 0;

const distanceOf = (obj) => {
  const d = obj['rows_experiment']?.['distance']?.['val']?.['val'];
  const numD = Number(d);
  return !isNaN(numD) && numD > 0 ? numD : null;
};

const per100Of = (obj, field) => {
  const dist = distanceOf(obj);
  if (dist === null) return null;
  return (100 * countOf(obj, field)) / dist;
};

const visibleViolations = (obj) =>
  violations
    .map((v) => ({
      ...v,
      count: countOf(obj, v.field),
      per100: per100Of(obj, v.field),
    }))
    .filter((v) => v.count > 0);

const objTotalCount = (obj) =>
  visibleViolations(obj).reduce((sum, v) => sum + v.count, 0);

const objTotalPer100 = (obj) => {
  const dist = distanceOf(obj);
  if (dist === null) return null;
  return (100 * objTotalCount(obj)) / dist;
};

const vehicleLabel = (obj) => {
  const model = obj['avtoModel'] || '';
  const name = obj['name'] || '';
  if (model || name) return `${model} ${name}`.trim();
  return '';
};

const formatCount = (value) => formatValue(value, 12);
const formatPer100 = (value) => formatValue(value, 7);

const formatValue = (value, format) => {
  if (value === null || value === undefined || value === '') return '';
  return props.data.format(value, format);
};
</script>

<style lang="scss">
.driving-safety-report__table {
  border-collapse: collapse;
  border: 1px solid black;
  caption-side: top;
  margin-right: 5px;
}

.driving-safety-report__vehicle-title {
  margin-top: 20px;
}

.margin-bottom {
  margin-bottom: 50px;
}
</style>
